module.exports = __webpack_public_path__ + "static/media/raport.cf467eb9.png";